export class WorkbookImpl {}
